import { InputFilterType } from '@share/common-types';
import CreditLineInvoices from '../../components/components/company-credit-line/credit-line-invoices';
import { useIntl } from 'react-intl';

const getCreditLineInvoiceSelect: any = (text: number) => (
  <CreditLineInvoices text={text} />
);

export const useMyCreditLineColumnMenu = () => {
  const intl = useIntl();
  return [

    {
      description: '#',
      key: 'creditLineInvoiceId',
      width: 90,
      display: true,
      order: 1,
      type: InputFilterType.IntegerNumber,
      displayConditions: true,
      component: getCreditLineInvoiceSelect,
    },
    {
      description: intl.formatMessage({ id: 'status' }),
      key: 'paymentStatus',
      width: 80,
      display: true,
      order: 3,
      type: InputFilterType.Text,
      displayConditions: false,
      sortable: false,
      component: (paid: string) => {
        return (
          <div>
            <span
              className={`commonBadge ${paid === 'pending'
                  ? 'commonBadge-warning'
                  : paid === 'partial'
                    ? 'commonBadge-danger'
                    : 'commonBadge-success'
                }`}
            >
              {paid}
            </span>
          </div>
        );
      },
    },
    {
      description: intl.formatMessage({ id: 'invoice.on' }),
      key: 'created',
      width: 135,
      incomingDateFormat: 'MM/DD/YYYY',
      display: true,
      order: 4,
      type: InputFilterType.Date,
      displayConditions: true,
    },
    {
      description: intl.formatMessage({ id: 'total' }),
      key: 'amount',
      width: 130,
      display: true,
      order: 5,
      type: InputFilterType.IntegerNumber,
      displayConditions: false,
      bold: true,
      component: (amount: string) => {
        return (
          <>
            <div className="d-flex align-items-center">
              <span className="totalValue">$ {amount}</span>
              <span className="dropDown pointer">
              </span>
            </div>
          </>
        );
      },
    },
    {
      description: intl.formatMessage({ id: 'paid' }),
      key: 'amount',
      width: 120,
      display: true,
      order: 6,
      type: InputFilterType.IntegerNumber,
      displayConditions: false,
    },
    {
      description: intl.formatMessage({ id: 'paid.on' }),
      key: 'paidDate',
      // filterFieldName: 'paidDate',
      width: 120,
      incomingDateFormat: 'MM/DD/YYYY',
      display: true,
      order: 7,
      type: InputFilterType.Date,
      displayConditions: false,
    },
    {
      description: intl.formatMessage({ id: 'due.date' }),
      key: 'dueDate',
      width: 120,
      incomingDateFormat: 'MM/DD/YYYY',
      display: true,
      order: 9,
      type: InputFilterType.Date,
      displayConditions: true,
    },
    {
      description: intl.formatMessage({ id: 'pdf' }),
      key: 'urlPdf',
      width: 80,
      display: true,
      order: 10,
      type: InputFilterType.Text,
      sortable: false,
      component: (_text: any, record: any) =>
        record.urlPdf ? (
          <a href={record.urlPdf} style={{ color: 'black' }} download target="_blank">
            <i className="bi bi-download"></i>
          </a>
        ) : null,
    },
  ]
}
